import React, { Component } from 'react';

import { chargeSignup, applySignupMemberSeat } from '../utils/openTablesApi';

// Mini-modal de cobro de una inscripción confirmada sin pago (enmienda For Test, FR-057).
// Dos puertas, mismo modal:
//  - mode="arrival": desde "Llegó" — cobrar Y validar la llegada en una acción, o "dejar en
//    cuenta" (validar la llegada sin cobrar: la entrada queda pendiente en la cuenta de la
//    mesa — S-08d). Si el COBRO falla, el error queda inline y la llegada NO se valida.
//  - mode="charge": sólo cobrar (fila de la inscripción sin check-in previo — S-08a — o
//    desglose de la cuenta de la mesa — FR-059).
// El importe real lo decide el backend (FR-058); el resumen de acá es informativo.
// "Es socio" (pedido del dueño, 2026-10-17): antes de cobrar, el mostrador puede aplicar el
// lugar sin cargo de un socio a la inscripción —uno de sus lugares deja de cobrarse—. Si era
// el único, ya no hay nada que cobrar y sólo queda validar la llegada.
// Molde de modal casero del repo: overlay a mano, sin Bootstrap JS.

// Ids de ticket_enum — mismo orden y default (POS) que el cobro de cuenta del salón.
const PAYMENTS = [[1, 'Efectivo'], [5, 'POS'], [2, 'Transferencia'], [3, 'MercadoPago']];
const DEFAULT_PAYMENT = 5;

class OpenTableChargeModal extends Component {

    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    componentDidUpdate(prevProps) {
        const id = this.props.signup && this.props.signup.id;
        const prevId = prevProps.signup && prevProps.signup.id;
        if ((this.props.show && !prevProps.show) || id !== prevId) {
            this.setState(this.initialState());
        }
    }

    // `charged`: el cobro de ESTA inscripción ya quedó registrado en este modal. Sólo se
    // enciende cuando la venta se emitió; el backend rechaza el segundo cobro con 7003.
    // `member`: el lugar de socio que se aplicó en este modal ({ chargeableSeats }); el prop
    // `signup` no se recarga, así que lo que cobra la inscripción sale de acá desde entonces.
    initialState = () => ({ paymentType: DEFAULT_PAYMENT, busy: false, error: null, charged: false, member: null, memberForm: null });

    // Lugares que se cobran: el del socio es sin cargo (backend §4.8).
    chargeableSeats = () => {
        const { signup } = this.props;
        if (this.state.member) return Number(this.state.member.chargeableSeats) || 0;
        return signup.chargeableSeats != null ? Number(signup.chargeableSeats) || 0 : Number(signup.seats) || 0;
    };

    submitMember = async () => {
        const form = this.state.memberForm || {};
        const cedula = String(form.cedula || '').replace(/\D/g, '');
        if (!cedula || this.state.busy) return;
        this.setState({ busy: true, error: null });
        try {
            const r = await applySignupMemberSeat(this.props.signup.id, cedula);
            const signup = (r && r.signup) || {};
            const left = signup.chargeableSeats != null ? Number(signup.chargeableSeats) : Math.max(0, this.chargeableSeats() - 1);
            this.setState({ busy: false, memberForm: null, member: { chargeableSeats: left } });
            if (this.props.onRefresh) this.props.onRefresh();
        } catch (error) {
            this.setState({ busy: false, error: error.message || 'No se pudo aplicar el lugar de socio' });
        }
    };

    renderMember() {
        const { signup } = this.props;
        const { member, memberForm, busy, charged } = this.state;
        if (member) {
            return <p className="text-success mb-3" style={{ fontSize: 13 }}>Socio: un lugar sin cargo aplicado.</p>;
        }
        if (charged || signup.memberSeat) return null;
        if (!memberForm) {
            return (
                <button type="button" className="btn btn-link btn-sm p-0 mb-3" style={{ fontSize: 13 }} disabled={busy}
                    onClick={() => this.setState({ memberForm: { cedula: '' }, error: null })}>
                    Es socio: aplicar su lugar sin cargo
                </button>
            );
        }
        return (
            <div className="mb-3">
                <label className="d-block mb-1"><small>Cédula del socio (su plan tiene que incluir mesa ese día)</small></label>
                <div className="d-flex" style={{ gap: 6 }}>
                    <input type="text" className="form-control form-control-sm" placeholder="Cédula" autoFocus
                        value={memberForm.cedula}
                        onChange={(e) => this.setState({ memberForm: { cedula: e.target.value }, error: null })}
                        onKeyDown={(e) => { if (e.key === 'Enter') this.submitMember(); }} />
                    <button type="button" className="btn btn-sm btn-accent text-nowrap" disabled={busy || !String(memberForm.cedula || '').trim()}
                        onClick={this.submitMember}>Aplicar</button>
                    <button type="button" className="btn btn-sm btn-white" disabled={busy}
                        onClick={() => this.setState({ memberForm: null, error: null })}>✕</button>
                </div>
            </div>
        );
    }

    // Cobra la inscripción; true si la venta quedó registrada. Ante un rechazo (p. ej. ya
    // estaba paga — S-08b: el backend no re-vende) el motivo queda inline y se corta acá.
    charge = async () => {
        try {
            await chargeSignup(this.props.signup.id, this.state.paymentType);
            return true;
        } catch (error) {
            this.setState({ busy: false, error: error.message || 'No se pudo cobrar' });
            return false;
        }
    };

    submitCharge = async () => {
        if (this.state.busy) return;
        this.setState({ busy: true, error: null });
        if (!(await this.charge())) return;
        this.setState({ busy: false });
        this.props.onDone();
    };

    /**
     * Valida la llegada y cierra. `charged` viaja por parámetro (y no leyendo el estado
     * después del await) porque decide el mensaje del fallo: con el cobro ya emitido, el
     * error NO es "no se pudo hacer nada", es "falta sólo la llegada".
     *
     * R-45: al fallar el check-in el modal QUEDA en estado cobrado. Antes seguía ofreciendo
     * "Cobrar y validar llegada" sobre el mismo signup (el prop no se recarga), así que el
     * reintento natural volvía a cobrar y comía un 7003 con la llegada todavía sin sellar.
     */
    runCheckIn = async (charged) => {
        try {
            await this.props.onCheckIn();
            this.setState({ busy: false });
            this.props.onDone();
        } catch (error) {
            const detalle = error.message || 'error de conexión';
            this.setState({
                busy: false,
                charged,
                error: charged
                    ? `El cobro quedó registrado, pero no se pudo validar la llegada: ${detalle}. Reintentá la llegada; no hay que volver a cobrar.`
                    : detalle,
            });
            // La fila ya quedó paga: que el listado lo muestre aunque el modal siga abierto.
            if (charged && this.props.onRefresh) this.props.onRefresh();
        }
    };

    submitChargeAndCheckIn = async () => {
        if (this.state.busy) return;
        this.setState({ busy: true, error: null });
        if (!(await this.charge())) return; // cobro fallido → NO se valida la llegada (S-08)
        await this.runCheckIn(true);
    };

    // Dos puertas al mismo paso: S-08d "dejar en cuenta" (sin venta) y, si el cobro ya salió,
    // el reintento de la llegada sola.
    submitCheckInOnly = async () => {
        if (this.state.busy) return;
        this.setState({ busy: true, error: null });
        await this.runCheckIn(this.state.charged);
    };

    render() {
        if (!this.props.show) return null;
        const { signup, unitPrice, mode } = this.props;
        const arrival = mode === 'arrival';
        // Se cobran los lugares que pagan: el del socio es sin cargo (backend §4.8).
        const seats = this.chargeableSeats();
        // Con el socio aplicado sobre su único lugar no queda nada que cobrar.
        const nothingToCharge = !!this.state.member && seats === 0;
        const price = unitPrice != null && Number(unitPrice) > 0 ? Number(unitPrice) : null;
        const lugares = `${seats} lugar${seats === 1 ? '' : 'es'}`;
        const { busy, error, charged } = this.state;
        return (
            <>
                <div className="modal fade show" style={{ display: 'block' }} role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" style={{ borderRadius: '0.75rem' }}>
                            <div className="modal-header">
                                <div>
                                    <h5 className="modal-title mb-1">
                                        {charged ? 'Cobrada — falta validar la llegada' : (arrival ? 'Llegó — cobrar la entrada' : 'Cobrar la inscripción')}
                                    </h5>
                                    <small className="text-muted">{signup.name || 'Sin nombre'}</small>
                                </div>
                                <button type="button" className="close" aria-label="Close" onClick={this.props.onClose} disabled={busy}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex justify-content-between align-items-baseline" style={{ borderBottom: '0.5px solid #eee', paddingBottom: 8, marginBottom: 12 }}>
                                    <span className="text-muted">Entradas</span>
                                    <span style={{ fontWeight: 500 }}>
                                        {price != null
                                            ? <>${seats * price} <small className="text-muted">({lugares} × ${price})</small></>
                                            : lugares}
                                    </span>
                                </div>
                                {this.renderMember()}
                                {/* Cobrada, el medio de pago ya no se elige: la venta está emitida. */}
                                {nothingToCharge ? (
                                    <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                                        No queda nada para cobrar.{arrival ? ' Falta validar la llegada.' : ''}
                                    </p>
                                ) : charged ? (
                                    <p className="text-success mb-0" style={{ fontSize: 13 }}>
                                        La entrada ya está cobrada. Falta sellar la llegada.
                                    </p>
                                ) : (
                                    <>
                                        <label className="d-block mb-1"><small>Medio de pago</small></label>
                                        <select className="form-control form-control-sm" value={this.state.paymentType}
                                            onChange={(e) => this.setState({ paymentType: Number(e.target.value) })}>
                                            {PAYMENTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                        </select>
                                        {arrival && (
                                            <p className="text-muted mt-2 mb-0" style={{ fontSize: 12 }}>
                                                "Dejar en cuenta" valida la llegada sin cobrar: la entrada queda pendiente
                                                en la cuenta de la mesa y se cobra después.
                                            </p>
                                        )}
                                    </>
                                )}
                                {error && <div className="alert alert-danger py-2 mt-3 mb-0" style={{ fontSize: 13 }}>{error}</div>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" onClick={this.props.onClose} disabled={busy}>
                                    Cancelar
                                </button>
                                {/* R-45: cobrado y sin llegada sellada, la única acción que falta es la
                                    llegada. Volver a cobrar acá termina siempre en 7003. */}
                                {nothingToCharge ? (
                                    arrival ? (
                                        <button type="button" className="btn btn-accent" onClick={this.submitCheckInOnly} disabled={busy}>
                                            {busy ? '...' : 'Validar llegada'}
                                        </button>
                                    ) : (
                                        <button type="button" className="btn btn-accent" onClick={this.props.onDone} disabled={busy}>
                                            Listo
                                        </button>
                                    )
                                ) : charged ? (
                                    <button type="button" className="btn btn-accent" onClick={this.submitCheckInOnly} disabled={busy}>
                                        {busy ? '...' : 'Reintentar validar llegada'}
                                    </button>
                                ) : arrival ? (
                                    <>
                                        <button type="button" className="btn btn-white" onClick={this.submitCheckInOnly} disabled={busy}>
                                            Dejar en cuenta
                                        </button>
                                        <button type="button" className="btn btn-accent" onClick={this.submitChargeAndCheckIn} disabled={busy}>
                                            {busy ? '...' : 'Cobrar y validar llegada'}
                                        </button>
                                    </>
                                ) : (
                                    <button type="button" className="btn btn-accent" onClick={this.submitCharge} disabled={busy}>
                                        {busy ? '...' : (price != null ? `Cobrar $${seats * price}` : 'Cobrar')}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        );
    }
}

export default OpenTableChargeModal;
